import { render, staticRenderFns } from "./ConsumeBox.vue?vue&type=template&id=60040660&scoped=true"
import script from "./ConsumeBox.vue?vue&type=script&lang=js"
export * from "./ConsumeBox.vue?vue&type=script&lang=js"
import style0 from "./ConsumeBox.vue?vue&type=style&index=0&id=60040660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60040660",
  null
  
)

export default component.exports